import React from "react";
import styles from "./Landing.module.css";
import appStore from "../../assets/appstore.svg";
import googlePlay from "../../assets/googleplay.svg";
import phone from "../../assets/phone.png";

export const Landing = () => {
  return (
    <div className={styles.pageContainer}>
      <div className={styles.container}>
        <div className={styles.left}>
          <h1 className={styles.title}>JustTalk - AI Therapy</h1>
          <p className={styles.subtext}>
            Improve your mental health with our AI therapists. Increase
            productivity, overcome depression, anxiety, sleep issues, and more.
          </p>
          <div className={styles.downloadImagesContainer}>
            <a href="https://apps.apple.com/app/justtalk/id6739946209">
              <img
                src={appStore}
                alt="Download on app store"
                className={`${styles.downloadButtonImage} ${styles.first}`}
              />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.originapps.justtalk">
              <img
                src={googlePlay}
                alt="Download on app store"
                className={styles.downloadButtonImage}
              />
            </a>
          </div>
        </div>
        <img src={phone} className={styles.phone} alt="Demo of app" />
      </div>
    </div>
  );
};
